import React, { useState } from "react"

import Image from './c/Image/Image'

import * as st from './FeatureList.styled.js'

const items = [
  {
    id: "custom-fields",
    name: "Custom fields",
    color: "red",
  },
  {
    id: "dynamic-texts",
    name: "Dynamic texts",
    color: "indigo",
  },
  {
    id: "sharing-quick-actions",
    name: "Sharing quick actions",
    color: "green",
  },
  {
    id: "magic-links",
    name: "Magic links for customer login",
    color: "blue",
  },
  {
    id: "form-templates",
    name: "Form templates",
    color: "red",
  },
  {
    id: "documents",
    name: "Documents",
    color: "indigo",
  },
  {
    id: "task-dependencies",
    name: "Task dependencies",
    color: "green",
  },
  {
    id: "checklists",
    name: "Checklists",
    color: "blue",
  },
  {
    id: "advanced-filters",
    name: "Advanced filters",
    color: "red",
  },
  {
    id: "advanced-grouping",
    name: "Advanced grouping",
    color: "indigo",
  },
  {
    id: "slack-canvases",
    name: "Auto-updated Slack canvases",
    color: "green",
  },
  {
    id: "internal-tasks",
    name: "Internal tasks",
    color: "blue",
  },
  {
    id: "internal-communication",
    name: "Internal communication",
    color: "red",
  },
  {
    id: "weekly-updates",
    name: "Weekly updates",
    color: "indigo",
  },
  {
    id: "personal-views",
    name: "Personal views",
    color: "green",
  },
  {
    id: "accounts-management",
    name: "Accounts management",
    color: "blue",
  },
  {
    id: "time-tracking",
    name: "Time-tracking",
    color: "red",
  },
  {
    id: "highlighting-fields",
    name: "Highlighting fields",
    color: "indigo",
  },
  {
    id: "branded-portal",
    name: "Branded customer portal",
    color: "green",
  },
  {
    id: "dark-mode",
    name: "Dark mode",
    color: "blue",
  },
  {
    id: "api",
    name: "API & Webhooks",
    color: "red",
  },
];

const FeatureList = () => {
  const [activeId, setActiveId] = useState("custom-fields");

  const activeItem = items.find(({ id }) => id === activeId) || {};

  return (
    <st.Wrap>
      <st.ListWrap>
        <st.Toc>
          {items.map(({ id }) => (
            <st.TocItem key={id} isActive={id === activeId} />
          ))}
        </st.Toc>
        <st.List>
          {items.map(({ id, name, color }) => (
            <st.Item key={id}>
              <st.Button
                isActive={id === activeId}
                onMouseEnter={() => setActiveId(id)}
              >
                {name}
              </st.Button>
              <st.InnerImage
                id={id}
                name={name}
                color={color}
              />
            </st.Item>
          ))}
        </st.List>
      </st.ListWrap>
      <st.ImageWrap>
        <Image
          id={activeId}
          name={activeItem.name}
          color={activeItem.color}
        />
      </st.ImageWrap>
    </st.Wrap>
  )
}

export default FeatureList
